import { Controller } from "@hotwired/stimulus";

// Keeps an element exactly as it is when Turbo morphs the page.
//
// A broadcast refresh morphs the live DOM towards a freshly rendered page, which
// is the wrong thing to do to two kinds of element on the educator dashboard:
// a lazily loaded turbo-frame, whose loaded content would be swapped back for
// the placeholder the server renders every time, and a select that TomSelect has
// decorated with markup the server never sends.
export default class extends Controller {
  connect() {
    this.element.addEventListener("turbo:before-morph-element", this.preserve);
  }

  disconnect() {
    this.element.removeEventListener(
      "turbo:before-morph-element",
      this.preserve,
    );
  }

  preserve = (event) => {
    if (event.target === this.element) event.preventDefault();
  };
}
